import { Link } from "react-router-dom";

const quickLinks = [
  { label: "全部动漫", path: "/categories" },
  { label: "新番索引", path: "/categories?cat=xinfan" },
  { label: "国漫专区", path: "/categories?cat=guoman" },
  { label: "日漫检索", path: "/categories?cat=riman" },
  { label: "番剧资讯", path: "/articles" },
  { label: "关于我们", path: "/about" },
];

const categoriesLinks = [
  "热血",
  "恋爱",
  "搞笑",
  "奇幻",
  "运动",
  "治愈",
  "悬疑",
].map((name) => ({ name }));

const catSlugMap: Record<string, string> = {
  热血: "rexue",
  恋爱: "lianai",
  搞笑: "gaoxiao",
  奇幻: "qihuan",
  运动: "yundong",
  治愈: "zhiyu",
  悬疑: "xuanyi",
};

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-800">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg font-heading text-lg bg-primary-500 text-background-50">
                漫
              </span>
              <span className="font-heading text-xl text-foreground-950">动漫网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed">
              动漫网是面向动漫爱好者的资源聚合检索入口，新番索引、漫画分类大全、国漫专区、日漫检索与动画库一站配齐，助你轻松找漫画、追更新。
            </p>
            <div className="mt-4 flex gap-3">
              <a href="#" rel="nofollow" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-bilibili-line text-base"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-music-2-line text-base"></i>
              </a>
            </div>
          </div>

          <nav aria-label="快速导航">
            <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="whitespace-nowrap text-foreground-700 hover:text-primary-600 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="动漫分类">
            <h3 className="font-heading text-base text-foreground-950">动漫分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {categoriesLinks.map((c) => (
                <li key={c.name}>
                  <Link to={`/categories?cat=${catSlugMap[c.name]}`} className="whitespace-nowrap text-foreground-700 hover:text-primary-600 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-base text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600"></i>
                <span>contact@anime.readdy.site</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600"></i>
                <span>客服在线 9:00 - 22:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-600"></i>
                <span>中国 · 线上服务平台</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/80">
        <div className="mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 px-4 md:px-6 py-5 text-xs text-foreground-600">
          <p>© 2026 动漫网 · 动漫网全部动漫列表 / 动漫网新番索引 / 动漫网漫画分类大全</p>
          <p className="whitespace-nowrap">仅供交流学习，侵权请联系删除</p>
        </div>
      </div>
    </footer>
  );
}